import React, { useEffect, useState } from "react";
import axios from "axios";
import "./../loader.css";

// Table layout follows the same card/table classes used in
// PatientList.js and ChatGptList.js. Unlike ChatGptList.js, "responces"
// for AppUser turns is already a plain string (not a JSON blob), so no
// JSON/regex parsing is needed here -- it's rendered as-is.
function UserChatHistory() {
  const [myCases, setMyCases] = useState([]);
  const [selectedCase, setSelectedCase] = useState("");
  const [turns, setTurns] = useState([]);
  const [isInitialLoading, setIsInitialLoading] = useState(true);
  const [loading, setLoading] = useState(false);

  const getToken = () => {
    try {
      const raw = localStorage.getItem("state");
      if (raw) {
        const state = JSON.parse(raw);
        return state.auth?.token;
      }
    } catch (e) {
      console.error("Token parsing failed", e);
    }
    return null;
  };

  useEffect(() => {
    const token = getToken();
    axios
      .get(`${process.env.REACT_APP_API_URL}/AppUser/GetMyCases`, {
        headers: { ...(token && { Authorization: `Bearer ${token}` }) },
      })
      .then((res) => {
        setMyCases(res.data || []);
        setIsInitialLoading(false);
      })
      .catch((err) => {
        console.error("Failed to load cases", err);
        setIsInitialLoading(false);
      });
  }, []);

  const fetchHistory = (patientId) => {
    if (!patientId) {
      setTurns([]);
      return;
    }
    setLoading(true);
    const token = getToken();
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/AppUser/GetChatHistory?patientId=${patientId}`,
        { headers: { ...(token && { Authorization: `Bearer ${token}` }) } }
      )
      .then((res) => {
        setTurns(res.data || []);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Failed to load chat history", err);
        setLoading(false);
      });
  };

  const onCaseChange = (e) => {
    setSelectedCase(e.target.value);
    fetchHistory(e.target.value);
  };

  return (
    <div className="page-content-wrapper">
      {isInitialLoading ? (
        <div className="page-content d-flex justify-content-center align-items-center">
          <div className="my-wrapper">
            <div className="spinner center">
              <div className="spinner-blade"></div>
              <div className="spinner-blade"></div>
              <div className="spinner-blade"></div>
              <div className="spinner-blade"></div>
              <div className="spinner-blade"></div>
              <div className="spinner-blade"></div>
              <div className="spinner-blade"></div>
              <div className="spinner-blade"></div>
              <div className="spinner-blade"></div>
              <div className="spinner-blade"></div>
              <div className="spinner-blade"></div>
              <div className="spinner-blade"></div>
            </div>
          </div>
        </div>
      ) : (
        <div className="page-content">
          <div className="page-bar">
            <div className="page-title-breadcrumb">
              <div className="pull-left">
                <div className="page-title my-0">Chat History</div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12 col-sm-12">
              <div className="card card-box">
                <div className="card-head">
                  <header>
                    <div className="row g-3 align-items-end">
                      <div className="col-md-5">
                        <label className="form-label">Select Case</label>
                        <select
                          className="form-control select2"
                          value={selectedCase}
                          onChange={onCaseChange}
                        >
                          <option value="">-- Choose Case --</option>
                          {myCases.map((c) => (
                            <option key={c.patient_Id} value={c.patient_Id}>
                              {c.case_Name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </header>
                </div>
                <div className="card-body">
                  {loading ? (
                    <p>Loading...</p>
                  ) : turns.length > 0 ? (
                    <div className="table-responsive">
                      <table className="table table-bordered table-hover">
                        <thead>
                          <tr>
                            <th>Date / Time</th>
                            <th>You said</th>
                            <th>Response</th>
                          </tr>
                        </thead>
                        <tbody>
                          {turns.map((t) => (
                            <tr key={t.id}>
                              <td style={{ whiteSpace: "nowrap" }}>
                                {t.timestamp}
                              </td>
                              <td>{t.question}</td>
                              <td>{t.responces}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  ) : (
                    <div className="text-center py-5">
                      <i className="fa fa-comments fa-3x" style={{ color: "#ccc" }} />
                      <p className="mt-3" style={{ color: "#999" }}>
                        {selectedCase
                          ? "No chat history yet for this case."
                          : "Select a case above to see your chat history."}
                      </p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default UserChatHistory;